import React from 'react';
import PropTypes from 'prop-types';

export default function Client({ client }) {
    const {
        name
    } = client;

    return (
        <li>{name}</li>
    );
}

Client.propTypes = {
    client: PropTypes.shape({
        name: PropTypes.string
    })
};

Client.defaultProps = {
    client: {}
};



// WEBPACK FOOTER //
// ./src/common/InfoPanel/SellerProfile/Clients/Client.js